export class CredentialPrimaryRenewalModel {
  formId?: string;
  formTitle?: string;

  constructor(data?: CredentialPrimaryRenewalModel) {
    if (!data) return;
    this.formId = data.formId;
    this.formTitle = data.formTitle;
  }
}
